//login.js
import { Breadcrumb } from "antd";
import React, { useState, useEffect, useContext } from "react";
import {
  FaEye,
  FaEyeSlash,
  FaCamera,
  FaUser,
  FaLock,
  FaBolt,
  FaBrain,
  FaRobot,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { login } from "../../utils/auth";
import { message } from "antd";
import { RootContext } from "../../context/RootContext";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ForgotPasswordModal from "./forgotPassword";
import axios from "../../utils/axios";
import { securePath } from "../../utils/secureRoutes";

// ─────────────────────────────────────────────
// Main Login Page
// ─────────────────────────────────────────────
const CogniVisioLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [showForgot, setShowForgot] = useState(false);
  const { dispatch } = useContext(RootContext);
  const navigate = useNavigate();
  const [showTrialExpired, setShowTrialExpired] = useState(false);
  const [trialExpiredMsg, setTrialExpiredMsg] = useState("");

  const handleSubmit = async () => {
    if (!username.trim() || !password.trim()) {
      return message.warning("Please enter credentials");
    }

    setLoading(true);
    try {
      const { data, error } = await login(username, password, false, "vision");

      if (error) {
        setLoading(false);

        const status = error.response?.status;

        if (status === 403) {
          setTrialExpiredMsg(
            error.response?.data?.message ||
            "Your free trial has expired. Please subscribe to continue using CogniVision."
          );
          setShowTrialExpired(true);
          return;
        }

        if (status === 401) {
          return message.error("Invalid username or password");
        }

        return message.error(
          error.response?.data?.message || "Something went wrong"
        );
      }

      message.success("Login Successful");

      // ✅ store organizationId
      localStorage.setItem("organizationId", data.organizationId);

      dispatch({ type: "LOGIN", user: data.user, admin: data.admin });

      // ✅ special users
      if (data.user?.toLowerCase().trim() === "growel") {
        navigate("/growelhome");
        return;
      }

      if (data.user?.toLowerCase().trim() === "tablespace") {
        navigate("/tablespacehome", { replace: true });
        return;
      }

      if (data.user?.toLowerCase().trim() === "prestige") {
        navigate(
          securePath("/prestigehome/dashboard"),
          {
            replace: true,
          }
        );

        return;
      }

      // ✅ Empire users – now identified by organizationId
      if (
        String(data.organizationId || "").trim().toUpperCase() ===
        "EMP-BAN-2026"
      ) {
        navigate(
          securePath(
            "/empirehome/dashboard",
            "/empirehome"
          ),
          { replace: true }
        );
        return;
      }

      if (data.user?.toLowerCase().trim() === "empire") {
        navigate(
          securePath("/empirehome/dashboard", {
            basePath: "/empirehome",
          }),
          { replace: true }
        );
        return;
      }

      if (data.user?.toLowerCase().trim() === "tanseeq") {
        navigate("/tanseeqhome", { replace: true });
        return;
      }

      if (username.toLowerCase() === "hkbk") {
        navigate("/userhome/Dashboard2", { replace: true });
        return;
      }

      // if (data.user?.toLowerCase().trim() === "admin@empire.com") {
      //   navigate("/empire/add-camera", {
      //     replace: true,
      //   });

      //   return;
      // }

      // 🔥 Fetch projects
      const payload = {
        username: data.user,
        organizationId: data.organizationId,
      };

      const projectRes = await axios.post("/select-project-list", payload);
      const projects = projectRes?.data?.projects || [];

      // ✅ check any configured project
      const hasConfiguredProject = projects.some(
        (p) => p.isDataflowConfigured || p.isCameraConfigured
      );

      try {

        const useCaseRes = await axios.post("fetch-user-usecase", {
          username: data.user,
          organizationId: data.organizationId,
        });

const userUseCases = useCaseRes?.data?.useCases || [];

const formattedUseCases = userUseCases.map((item) => {
  if (typeof item === "string") {
    return item.trim().toLowerCase();
  }

  if (item?.id) {
    return item.id.trim().toLowerCase(); // ✅ THIS IS THE FIX
  }

  return null;
}).filter(Boolean);

localStorage.setItem("selectedUseCases", JSON.stringify(formattedUseCases));

      } catch (ucErr) {
        console.error("Error fetching usecases", ucErr);
        localStorage.setItem("selectedUseCases", JSON.stringify([]));
      }

      // 🚀 navigation
      if (hasConfiguredProject) {
        navigate("/select-project", { replace: true });
      } else {
        navigate("/demodashboard", { replace: true });
      }

    } catch (err) {
      const status = err.response?.status;

      if (status === 403) {
        message.error(
          err.response?.data?.message ||
          "Your free trial has expired. Please subscribe to continue using CogniVision."
        );
      } else if (status === 401) {
        message.error("Invalid username or password");
      } else {
        message.error(err.response?.data?.message || "Something went wrong");
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    const checkProjectsAndRedirect = async () => {
      const citriot = JSON.parse(localStorage.getItem("citriot"));
      const organizationId = localStorage.getItem("organizationId");

      if (citriot && citriot.auth?.isLoggedIn) {
        const loggedInUser = citriot.auth.user?.toLowerCase().trim();

        // ✅ Special users
        if (loggedInUser === "growel") {
          navigate("/growelhome", { replace: true });
          return;
        }

        if (loggedInUser === "tablespace") {
          navigate("/tablespacehome", { replace: true });
          return;
        }

       if (loggedInUser === "prestige") {
        navigate(
          securePath("/prestigehome/dashboard"),
          {
            replace: true,
          }
        );

        return;
      }

      if (loggedInUser === "prestige_user") {
        navigate(
          securePath("/prestigehome/dashboard"),
          {
            replace: true,
          }
        );

        return;
      }

        // ✅ Empire users – now identified by organizationId
        if (
          String(organizationId || "").trim().toUpperCase() ===
          "EMP-BAN-2026"
        ) {
          navigate(
            securePath(
              "/empirehome/dashboard",
              "/empirehome"
            ),
            { replace: true }
          );
          return;
        }

        if (loggedInUser === "tanseeq") {
          navigate("/tanseeqhome", { replace: true });
          return;
        }

        if (loggedInUser === "hkbk") {
          navigate("/userhome/Dashboard2", { replace: true });
          return;
        }

        try {
          const payload = {
            username: citriot.auth.user,
            organizationId,
          };

          const res = await axios.post("/select-project-list", payload);
          const projects = res?.data?.projects || [];

          const hasConfiguredProject = projects.some(
            (p) => p.isDataflowConfigured || p.isCameraConfigured
          );

          if (hasConfiguredProject) {
            navigate("/select-project", { replace: true });
          } else {
            navigate("/demodashboard", { replace: true });
          }
        } catch (err) {
          console.error("Error checking projects", err);
          navigate("/demodashboard", { replace: true });
        }
      }
    };

    checkProjectsAndRedirect();
  }, [navigate]);

  const TrialExpiredModal = ({ message: msg, onClose }) => {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        {/* Backdrop */}
        <div
          className="absolute inset-0 bg-slate-900/60 backdrop-blur-sm"
          onClick={onClose}
        />

        {/* Modal */}
        <div className="relative z-10 w-full max-w-sm bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl border border-white/30 overflow-hidden animate-modal-in">
          {/* Top gradient bar — amber/orange for warning */}
          <div className="h-1.5 w-full bg-gradient-to-r from-blue-600 to-purple-600 to-red-500" />

          <div className="p-8 flex flex-col items-center text-center gap-5">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full bg-amber-50 border-2 border-amber-200 flex items-center justify-center shadow-lg shadow-amber-100">
              <svg
                className="w-8 h-8 text-amber-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
                />
              </svg>
            </div>

            {/* Title */}
            <div>
              <h2 className="text-xl font-bold text-slate-800 mb-1">
                Free Trial Expired
              </h2>
              <p className="text-sm text-slate-500 leading-relaxed">
                {msg ||
                  "Your free trial has expired. Please subscribe to continue using CogniVision."}
              </p>
            </div>

            {/* Divider */}
            <div className="w-full h-px bg-slate-100" />

            {/* Actions */}
            <div className="flex flex-col gap-3 w-full">

              <button
                onClick={onClose}
                className="w-full h-11 bg-slate-100 hover:bg-slate-200 rounded-xl text-slate-600 font-semibold text-sm transition-all duration-300"
              >
                Close
              </button>
            </div>
          </div>
        </div>

        <style>{`
          @keyframes modal-in {
            from { opacity: 0; transform: scale(0.92) translateY(16px); }
            to   { opacity: 1; transform: scale(1) translateY(0); }
          }
          .animate-modal-in { animation: modal-in 0.3s cubic-bezier(0.34,1.56,0.64,1) both; }
        `}</style>
      </div>
    );
  };

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 flex items-center justify-center p-4 relative overflow-hidden">
        {/* ── Breadcrumb ── */}
        <div className="absolute top-6 left-6 z-30">
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => navigate("/landing-page")}
              className="cursor-pointer text-slate-600 hover:text-blue-600 font-medium"
            >
              <ArrowLeftOutlined className="mr-1" />
              Back
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text-slate-400">
              Vision Login
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="absolute inset-0 overflow-hidden">
          {[...Array(8)].map((_, i) => (
            <div
              key={i}
              className="absolute w-2 h-2 bg-blue-400/30 rounded-full animate-pulse"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`,
              }}
            />
          ))}
          <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gradient-to-r from-blue-300/20 to-purple-300/20 rounded-full blur-3xl animate-pulse" />
          <div
            className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-gradient-to-r from-cyan-300/20 to-blue-300/20 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          />
        </div>

        {/* Main Container */}
        <div className="relative z-10 w-full max-w-4xl mx-auto">
          <div className="bg-white/80 backdrop-blur-xl border border-white/20 rounded-3xl shadow-2xl overflow-hidden transition-all duration-500 hover:shadow-blue-200/50">
            <div className="flex flex-col lg:flex-row min-h-[600px]">

              {/* Left Section - Login Form */}
              <div className="lg:w-3/5 p-8 lg:p-12 flex flex-col justify-center">
                <div className="w-full max-w-md mx-auto">
          
                  {/* Header */}
                  <div className="text-center mb-10">
                    <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 via-blue-600 to-indigo-700 bg-clip-text text-transparent mb-3 tracking-tight">
                      CogniVision
                    </h1>
                    <div className="flex items-center justify-center gap-2 text-slate-600 mb-4">
                      <FaBrain className="w-4 h-4 text-blue-500 animate-pulse" />
                      <span className="text-sm font-medium">AI-Powered Intelligence</span>
                    </div>
                    <p className="text-slate-500 text-sm">
                      Welcome back to your visual intelligence dashboard
                    </p>
                  </div>

                  {/* Form */}
                  <form
                    onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}
                    className="space-y-6"
                  >
                    {/* Username Field */}
                    <div className="relative group">
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-indigo-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      <FaUser
                        className={`absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-all duration-300 ${
                          focusedField === "username" ? "text-blue-500 scale-110" : "text-slate-400"
                        }`}
                      />
                      <input
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onFocus={() => setFocusedField("username")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Enter your username"
                        className="w-full h-14 pl-12 pr-4 bg-white/70 border border-slate-200 rounded-xl text-slate-800 placeholder-slate-400 focus:outline-none focus:border-blue-400 focus:bg-white focus:shadow-lg hover:border-slate-300 transition-all duration-300 relative z-10"
                        required
                      />
                      <div
                        className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-500 transition-all duration-300 ${
                          focusedField === "username" ? "w-full" : "w-0"
                        }`}
                      />
                    </div>

                    {/* Password Field */}
                    <div className="relative group">
                      <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-purple-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
                      <FaLock
                        className={`absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5 transition-all duration-300 ${
                          focusedField === "password" ? "text-indigo-500 scale-110" : "text-slate-400"
                        }`}
                      />
                      <input
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={() => setFocusedField("password")}
                        onBlur={() => setFocusedField(null)}
                        placeholder="Enter your password"
                        className="w-full h-14 pl-12 pr-12 bg-white/70 border border-slate-200 rounded-xl text-slate-800 placeholder-slate-400 focus:outline-none focus:border-indigo-400 focus:bg-white focus:shadow-lg hover:border-slate-300 transition-all duration-300 relative z-10"
                        required
                      />
                      <button
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                        className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-all duration-300 hover:scale-110 z-20"
                      >
                        {showPassword ? <FaEyeSlash className="w-5 h-5" /> : <FaEye className="w-5 h-5" />}
                      </button>
                      <div
                        className={`absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-indigo-500 to-purple-500 transition-all duration-300 ${
                          focusedField === "password" ? "w-full" : "w-0"
                        }`}
                      />
                    </div>

                    {/* Login Button */}
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full h-14 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 rounded-xl text-white font-semibold text-lg transition-all duration-300 transform hover:scale-105 hover:shadow-xl disabled:opacity-70 disabled:cursor-not-allowed relative overflow-hidden group"
                    >
                      <div className="absolute inset-0 bg-white/10 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                      <span className="flex items-center justify-center gap-3 relative z-10">
                        {loading ? (
                          <>
                            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            <span>Authenticating...</span>
                          </>
                        ) : (
                          <>
                            <FaBrain className="w-5 h-5 animate-pulse" />
                            <span>Access Dashboard</span>
                          </>
                        )}
                      </span>
                    </button>
                  </form>

                  {/* Footer */}
                  <div className="mt-8 text-center space-y-4">
                    {/* ✅ Forgot password button – now opens modal */}
                    <button
                      onClick={() => setShowForgot(true)}
                      className="text-sm text-slate-500 hover:text-blue-500 transition-colors duration-300 relative group"
                    >
                      <span className="relative">
                        Forgot your credentials?
                        <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-blue-500 group-hover:w-full transition-all duration-300" />
                      </span>
                    </button>
                    <div className="flex items-center justify-center gap-2 text-xs text-slate-400">
                      <FaBolt className="w-3 h-3 text-yellow-500 animate-pulse" />
                      <span>Powered by Citriot</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Section - AI Visual */}
              <div className="lg:w-2/5 bg-gradient-to-br from-blue-500/90 to-indigo-600/90 p-8 lg:p-12 flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                  <div className="grid grid-cols-8 gap-4 h-full">
                    {[...Array(64)].map((_, i) => (
                      <div
                        key={i}
                        className="bg-white rounded-sm animate-pulse"
                        style={{ animationDelay: `${Math.random() * 2}s` }}
                      />
                    ))}
                  </div>
                </div>
                <div className="relative z-10 text-center text-white">
                  <h2 className="text-3xl font-bold mb-4">Welcome Back</h2>
                  <p className="text-blue-100 text-lg mb-8 leading-relaxed">
                    Step into the future of intelligent visual monitoring and analytics
                  </p>
                  <div className="grid grid-cols-2 gap-4">
                    {[
                      { icon: <FaCamera className="w-4 h-4" />, text: "Smart Vision" },
                      { icon: <FaBrain className="w-4 h-4" />, text: "AI Analytics" },
                      { icon: <FaBolt className="w-4 h-4" />, text: "Real-time" },
                      { icon: <FaRobot className="w-4 h-4" />, text: "Automated" },
                    ].map((feature, index) => (
                      <div
                        key={index}
                        className="flex items-center gap-2 p-3 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20 hover:bg-white/20 transition-all duration-300 transform hover:scale-105"
                      >
                        <div className="text-blue-200">{feature.icon}</div>
                        <span className="text-sm font-medium text-blue-100">{feature.text}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
      {showForgot && <ForgotPasswordModal onClose={() => setShowForgot(false)} />}

      {/* Trial Expired Modal */}
      {showTrialExpired && (
        <TrialExpiredModal
          message={trialExpiredMsg}
          onClose={() => setShowTrialExpired(false)}
        />
      )}
    </>
  );
};

export default CogniVisioLogin;